import React from 'react';
import { Row, Col, Card, Button, Modal, Popconfirm } from 'antd';
import NoteModel from './NoteModel'
import { DeleteOutlined, FormOutlined } from '@ant-design/icons';
import _ from 'lodash';
import API from '@/api'

class Note extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      list: [],
      visible: false
    }
  }

  componentDidMount () {
    this.GetNoteList()
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = async e => {
    const { state } = this
    // console.log(e);
    // this.props.sendData = 
    const rre = await this.refs.NoteModel.vaild()
    console.log('rrerre', rre)

    const data = _.pick(rre, ['id', 'title', 'intro', 'content'])
    const res = await API.SaveNote(data)
    if (res.code !== 200) return

    if (!rre) return
    
    this.refs.NoteModel.clear()
    
    if (rre.id) {
      const newList = [ ...state.list ]
      const index = _.findIndex(state.list, { id: rre.id })
      newList[index] = rre
      this.setState(state => ({
        list: newList
      }))
    } else {
      rre.id = (+new Date()).toString()
      this.setState(state => {
        return state.list.push(rre)
      })
    }

    this.setState({
      visible: false,
    });
  };

  handleCancel = async e => {
    console.log(e);
    await this.refs.NoteModel.clear()
    this.setState({
      visible: false,
    });
  };

  addNote () {
    this.showModal()
  }

  async del (index) {
    const delRes = await API.DelNote({
      id: this.state.list[index].id
    })
    if (delRes.code !== 200) return
    this.setState(state => {
      return state.list.splice(index, 1)
    })
  }

  async GetNoteList () {
    const res = await API.GetNote()
    if (res.code !== 200) return

    this.setState({
      list: res.result.rows
    })
  }

  async edit (index) {
    await this.showModal()
    this.refs.NoteModel.edit(this.state.list[index])
  }

  render () {
    const { state } = this
    return (
      <div>
        <Row gutter={16}>
          <Col span={24}>
            <Button
              type="default"
              size="small"
              style={{ width: '100%' }}
              onClick={() => this.addNote()}
            >新增</Button>
          </Col>
        </Row>
        <Modal
          title="Basic Modal"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width={800}
        >
          <NoteModel ref="NoteModel" />
        </Modal>
        <Row gutter={16} style={{ marginTop: '16px' }}>
          {
            state.list.map((item, index) => {
              return (
                <Col span={6} key={index}>
                  <Card
                    title={item.title}
                    extra={
                      <div>
                        <FormOutlined onClick={() => this.edit(index)} />
                        <Popconfirm
                          title="确定删除?"
                          onConfirm={() => this.del(index)}
                          okText="Yes"
                          cancelText="No"
                        >
                          <DeleteOutlined
                            style={{ marginLeft: 8 }}
                          />
                        </Popconfirm>
                      </div>
                    }
                    style={{
                      height: '240px'
                    }}
                  >
                    <p>{item.intro}</p>
                  </Card>
                </Col>
              )
            })
          }
        </Row>
      </div>
    )
  }
}

export default Note;
